var videoLoaded = false,
minVideoLoad = 0.01, // seconds
maxTimeForLoad = 5 * 1000; // miliseconds

function removeVideos(videos) {
	jQuery(videos).remove();
	jQuery('.black-card').css('display', 'none');
}

function hideVideos(videos, args) {
	if (args.fadeOut) {
		jQuery(videos).fadeOut(1200, function() {
			removeVideos();
		}); 
	} else {
		removeVideos();
	}
}

jQuery(document).ready(function() {
	//variables
	var body = jQuery('body'),
		$mainHero = jQuery('.main'),
		$mainHeroContainer = jQuery('.main').find('.container-fluid'),
		$heroContainers = jQuery('.hero').find('.container-fluid'),
		$menuIcon = jQuery('#menu-icon'),
		$menu = jQuery('.menu'),
		$headerLogo = jQuery('.mobile-logo'),
		$galleryGrid = jQuery('#gallery-grid').find('.row'),
		$sectionsNav = jQuery('.sections-nav'),
		heroSections = jQuery('.hero-content'),
		videos = jQuery('iframe.background-video'),
		aboutAnchors = ['about-hero', 'section1', 'section2'],
		aboutFullpage = jQuery('#fullpage-about'),
		hasFullpage = jQuery('.has-fullpage'),
		$allSectionContent = jQuery('.section *:not(.background-video)');

	if(Modernizr.touchevents){
		hideVideos(videos, {fadeOut: false});		
	}

	switch (body.attr('id')) {

		case "about":

			aboutPageLoaded();
			break;
		case "contact":

			contactPageLoaded();
			break;
		case "gallery":

			galleryPageLoaded();
			break;
		case "home":

			homePageLoaded();
			break;
		case "portfolio":

			portfolioPageLoaded();
			break;
		case "standards":

			standardsPageLoaded();
			break;
		default:

			break;
	}

	function resizeVideoRatio(video){
		var screenRatio = window.innerWidth/window.innerHeight;
		var videoRatio = 16/9;
		if (screenRatio > videoRatio) {

			var newRatio = screenRatio / (videoRatio);
			jQuery(video).css('height', newRatio * 100 + "%");
			jQuery(video).css('width', "100%");
		} else {

			var newRatio = (videoRatio) / screenRatio;
			jQuery(video).css('height', "100%");
			jQuery(video).css('width', newRatio * 100 + "%");
		}
	}

	$menuIcon.on('click', toggleMenu);

	videos.each(function(index) {

		resizeVideoRatio(videos[index]);
		jQuery(window).resize(function(){

			resizeVideoRatio(videos[index]);
		});
	});

	var menuAnimationInProgress = false;

	function toggleMenu(event){
		if (menuAnimationInProgress) return;
		menuAnimationInProgress = true;
		$menuIcon.find('.hamburger-menu').toggleClass('is-open');

		if ($menu.hasClass('open')) {
			jQuery('.menu-labels #open').fadeTo(150, 1);
			jQuery('.menu-labels #close').fadeTo(150, 0);
			hideElements($menu.find('.nav-wrapper'), 50, function() {
				$menu.removeClass('open');

				setTimeout(function() {
					body.removeClass('no-overflow');
					$menu.addClass('hide');
					menuAnimationInProgress = false;
				}, 1000);

				$allSectionContent.fadeTo(150, 1);
				$headerLogo.fadeTo(150, 1);
				$sectionsNav.fadeTo(150, 1);
			});
		} else {
			$menu.removeClass('hide');

			setTimeout(function() {
				body.addClass('no-overflow');
				$menu.addClass('open');
				showElements($menu.find('.nav-wrapper'), 50, null, true);
			}, 1);
			jQuery('.menu-labels #open').fadeTo(150, 0);
			jQuery('.menu-labels #close').fadeTo(150, 1);
			$allSectionContent.fadeTo(150, 0);

			if (jQuery(window).width() >= 768) {
				$headerLogo.fadeTo(500, 0);
			}
 
			$sectionsNav.fadeTo(150, 0);
			setTimeout(function() {
				menuAnimationInProgress = false;
			}, 800);
		}
	}

	function showElements($container, time, callback, isMenuItemAnimation) {
		$container.children().each(function(index) {
			if (jQuery(this).is('hr')) {
				jQuery(this).addClass('animate');
				if(isMenuItemAnimation){
					jQuery(this).delay(index * time).fadeTo(time, 0.75);	
				}
			} else if (index >= 1) {

				jQuery(this).delay(index * time).fadeTo(time, 1);
			} else {

				jQuery(this).fadeTo(time, 1);
			}

			if (index === $container.children().length - 1 && callback != undefined) {

				setTimeout(function() {
					callback();
				}, time);
			}
		});
	}

	function hideElements($container, time, callback) {
		var childrenArray = $container.children().toArray();
		var containerChildren = $container.children();
		var counter = 0;

		if (time == undefined) {

			time = 500;
		}

		for (var i = childrenArray.length - 1; i >= 0; i--) {
			if (i < childrenArray.length - 1) {
				counter ++;
			}

			jQuery(containerChildren[i]).delay(counter * time).fadeTo(time, 0);

			if (i === 0 && callback != undefined) {

				setTimeout(function() {
					callback();
				}, time);
			}
		}
	}

	setTimeout(function() {
		showElements($galleryGrid);
	}, 2000);

	$menuIcon.delay(3000).fadeTo(600, 1);
	$headerLogo.delay(3000).fadeTo(600, 1);

	jQuery(window).load(function() {
		jQuery('.hero-content .container-fluid').each(function() {

			var container = jQuery(this);
			container.waypoint(function() {
				showElements(container, 800);
			}, {
				offset: '100%'
			});
		});
	});

	jQuery('.sidebar-copy').each(function() {

		var element = jQuery(this);
		element.waypoint(function() {
			element.children('.overlay').delay(500).fadeTo('3000', 1);
			element.children('.copy').delay(700).fadeTo('1200', 1);
		}, {
			offset: '25%'
		});
	});

	jQuery('.thumb-text').each(function(i) {

		var element = jQuery(this);
		var delay = 1000 + (i * 250);
		element.waypoint(function() {

			element.delay(delay).fadeTo('600', 1);
		}, {
			offset: '100%'
		});
	});


	jQuery('.scroll-down').click(function() {
		jQuery('html, body').animate({
			scrollTop: window.innerHeight
		}, 600);
	});
});